import './styles/styles.scss';
import '@yesplz/visualfilter/src/modules/analytics';
import Product from './Product';

export default Product;

export {
  Product,
};
